import { ComponentContext, elementsToShapes, SeatingViewerContext, IconType, Rotate, } from '@wix/seating-common-components';
import { Enter, Exit, Elevator, Stairs, Bar, Cutlery, Smoking, Wc, WcWomen, WcMen, Stage, Checkroom, } from 'wix-ui-icons-common';
import React, { useEffect, useMemo, useState } from 'react';
import { colorToRgba } from '@wix/panda-js-utils';
import { Seat } from '../seat';
import { Area } from '../area';
import { Table } from '../table';
import { RoundTable } from '../round-table';
import { Shapes } from '../shapes';
import s from './plan.scss';
const getShapeMeasureHook = (id) => `shape-measure-rect-${id}`;
const STAGE_HOOK = 'seating-stage';
export const Plan = ({ plan, svgViewBox, currentlyClickedPlaceId, selectedPlaceIds = [], placesStock = {}, mobile = false, noBackground = false, onPlaceClick, onPlaceMouseEnter, onPlaceMouseLeave, onShapeClick, onShapeMouseEnter, onShapeMouseLeave, PerShapeComponent, getPerShapeComponentProps, shapeTypeConfig = {}, uiPropertiesEnabled = false, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const shapes = useMemo(() => elementsToShapes(plan, true, uiPropertiesEnabled).sort((a, b) => { var _a, _b; return ((_a = a.sortId) !== null && _a !== void 0 ? _a : 0) - ((_b = b.sortId) !== null && _b !== void 0 ? _b : 0); }), [plan, uiPropertiesEnabled]);
    const backgroundColor = uiPropertiesEnabled
        ? colorToRgba((_a = plan.uiProperties) === null || _a === void 0 ? void 0 : _a.backgroundColor, ((_b = plan.uiProperties) === null || _b === void 0 ? void 0 : _b.backgroundOpacity) !== undefined ? ((_c = plan.uiProperties) === null || _c === void 0 ? void 0 : _c.backgroundOpacity) / 100 : undefined)
        : colorToRgba((_e = (_d = plan.config) === null || _d === void 0 ? void 0 : _d.background) === null || _e === void 0 ? void 0 : _e.backgroundColor, (_g = (_f = plan.config) === null || _f === void 0 ? void 0 : _f.background) === null || _g === void 0 ? void 0 : _g.backgroundOpacity);
    const MemoizedPerShapeComponent = useMemo(() => PerShapeComponent, []);
    const [boundingRectangles, setBoundingRectangles] = useState(null);
    useEffect(() => {
        if (MemoizedPerShapeComponent) {
            const wrapperEl = document.querySelector(`[data-hook="${STAGE_HOOK}"]`);
            const wrapperBox = wrapperEl.getBoundingClientRect();
            const rectangles = {};
            shapes.forEach(shape => {
                const el = document.querySelector(`[data-hook="${getShapeMeasureHook(shape.id)}"]`);
                const box = el.getBoundingClientRect();
                rectangles[shape.id] = Object.assign(Object.assign({}, box), { left: box.left - wrapperBox.left, top: box.top - wrapperBox.top, right: box.right - wrapperBox.left, bottom: box.bottom - wrapperBox.top, x: box.x - wrapperBox.x, y: box.y - wrapperBox.y });
            });
            setBoundingRectangles(rectangles);
        }
        return () => {
            setBoundingRectangles(null);
        };
    }, [MemoizedPerShapeComponent, shapes, svgViewBox]);
    const viewerComponents = useMemo(() => ({
        Seat,
        Area,
        Table,
        RoundTable,
        PointerArea: () => null,
        SelectionMarker: () => null,
        Icons: {
            [IconType.enter]: Enter,
            [IconType.exit]: Exit,
            [IconType.elevator]: Elevator,
            [IconType.stairs]: Stairs,
            [IconType.drinks]: Bar,
            [IconType.food]: Cutlery,
            [IconType.smoking]: Smoking,
            [IconType.wc]: Wc,
            [IconType.wcWomen]: WcWomen,
            [IconType.wcMen]: WcMen,
            [IconType.stage]: Stage,
            [IconType.checkroom]: Checkroom,
        },
        backgroundColor,
    }), [backgroundColor]);
    const seatingViewContextValue = useMemo(() => ({
        currentlyClickedPlaceId,
        selectedPlaceIds,
        placesStock,
        mobile,
        onPlaceClick,
        onPlaceMouseEnter,
        onPlaceMouseLeave,
        shapeTypeConfig,
    }), [
        currentlyClickedPlaceId,
        selectedPlaceIds,
        placesStock,
        mobile,
        onPlaceClick,
        onPlaceMouseEnter,
        onPlaceMouseLeave,
        shapeTypeConfig,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement("svg", { "data-hook": STAGE_HOOK, xmlns: "http://www.w3.org/2000/svg", className: s.plan, viewBox: svgViewBox, style: noBackground ? undefined : { backgroundColor } },
            MemoizedPerShapeComponent
                ? shapes.map(shape => (React.createElement(Rotate, { key: shape.id, rotateX: shape.x + Math.round(shape.width / 2), rotateY: shape.y + Math.round(shape.height / 2), angle: shape.angle },
                    React.createElement("rect", { "data-hook": getShapeMeasureHook(shape.id), x: shape.x, y: shape.y, width: shape.width, height: shape.height, style: { visibility: 'hidden' } }))))
                : null,
            React.createElement(ComponentContext.Provider, { value: viewerComponents },
                React.createElement(SeatingViewerContext.Provider, { value: seatingViewContextValue },
                    React.createElement(Shapes, { shapes: shapes, onShapeClick: onShapeClick, onShapeMouseEnter: onShapeMouseEnter, onShapeMouseLeave: onShapeMouseLeave })))),
        MemoizedPerShapeComponent && boundingRectangles
            ? shapes.map(shape => (React.createElement(MemoizedPerShapeComponent, { key: shape.id, definition: shape, boundingRectangle: boundingRectangles[shape.id], passedProps: getPerShapeComponentProps === null || getPerShapeComponentProps === void 0 ? void 0 : getPerShapeComponentProps(shape) })))
            : null));
};
//# sourceMappingURL=plan.js.map